import { useEffect, useRef, useState } from 'react';

function isOverflownWindow(element: any) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

export const useResizeWindow = (ref?: any, setTabsOverflow?: any) => {
  const [state, setState] = useState<{ width: number; height: number }>({
    width: window.innerWidth,
    height:window.innerHeight,
  });

  const handlerResize = () => {
    const element = ref?.current;
    if (!element) {
      return;
    }
    if (isOverflownWindow(element)) {
      setTabsOverflow(true);
    } else {
      setTabsOverflow(false);
    }
  };

  const sizeHandler = () => {
    setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener('resize', handlerResize);
    window.addEventListener('resize', sizeHandler);

    return () => {
      window.removeEventListener('resize', handlerResize);
      window.removeEventListener('resize', sizeHandler);
    };
  }, [ref]);

  return {
    handlerResize,
    width: state.width,
    height: state.height
  };
};
